import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth, signInWithCustomToken } from "firebase/auth";

export default function SingpassCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const code = searchParams.get("code");
    const state = searchParams.get("state");

    if (!code || !state) {
      setError("Missing Singpass response. Please try logging in again.");
      return;
    }

    (async () => {
      try {
        const functions = getFunctions();
        const singpassExchange = httpsCallable(functions, "singpassExchange");
        const { data } = await singpassExchange({ code, state });
        await signInWithCustomToken(getAuth(), data.customToken);
        await getAuth().currentUser.reload();
        navigate("/");
      } catch (err) {
        setError("Singpass login failed. Please try again.");
      }
    })();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#091E1B] text-white">
      {error ? (
        <div className="text-center">
          <p className="text-red-300 mb-4">{error}</p>
          <button onClick={() => navigate("/login")} className="text-[#D4AF37] underline">
            Back to login
          </button>
        </div>
      ) : (
        <p className="text-white/50">Completing Singpass login…</p>
      )}
    </div>
  );
}